import config from 'common/config';
import callApi from 'helpers/apiCaller';
import $ from 'jquery';

// Hàm chia phần môn chung
export function divideSubject(arrSubject, slicePoints) {
  let part1 = arrSubject.slice(0, slicePoints[0]);
  if (slicePoints[1] != 0) {
    let part2 = arrSubject.slice(slicePoints[0], slicePoints[1]);
    if (slicePoints[2] != 0) {
      let part3 = arrSubject.slice(slicePoints[1], slicePoints[2]);
      return { part1, part2, part3 };
    }
    return { part1, part2 };
  }
  return {part1};
}

// Hàm cho loại 1: Toán
export function divideSubjectType1(arrSubject) {
  return divideSubject(arrSubject, [12, 16, 22]);
}

// Hàm cho loại 2: Lý, Hóa, Sinh, Địa
export function divideSubjectType2(arrSubject) {
  return divideSubject(arrSubject, [18, 22, 28]);
}

// Hàm cho loại 3: Sử, GDCD, CN công nghiệp, CN nông nghiệp
export function divideSubjectType3(arrSubject) {
  return divideSubject(arrSubject, [24, 4, 0]);
}

// Hàm cho loại 4: Anh
export function divideSubjectType4(arrSubject) {
  return divideSubject(arrSubject, [40, 0, 0]);
}

// Hàm cho loại 5: Tin
export function divideSubjectType5(arrSubject) {
  return divideSubject(arrSubject, [24, 6, 0]);
}

export function saveToLocalStoragePart3(chkId, vl) {
  let storedData = JSON.parse(localStorage.getItem('answersPart3Math'));
  if (!storedData) {
    localStorage.setItem("answersPart3Math", JSON.stringify([]));
  } else {
    let existingItemIndex = storedData.findIndex(item => item.key === chkId);

    if (existingItemIndex > -1) {
      // nếu đã tồn tại, cập nhật giá trị
      storedData[existingItemIndex].value = vl;
    } else {
      // nếu chưa tồn tại, thêm mới đối tượng vào mảng
      storedData.push({ key: chkId, value: vl });
    }

    localStorage.setItem('answersPart3Math', JSON.stringify(storedData));
  }
}

// Hàm lấy dữ liệu parse vào cho phần 3
export function getDataFromArrQuestion(arrQuestion, questionId) {
  if (arrQuestion) {
    const foundObj = arrQuestion?.find((obj) => obj.key == questionId);
    return foundObj ? foundObj.value : '';
  }
  return ""
}

// Hàm tách đáp án chuỗi phần 2 
export function transformAnswers(data) {
  return data.map(item => {
    const transformed = {};
    item.arrAnswer.forEach(answer => {
      const key = answer.slice(0, 2);
      const value = answer.slice(2);
      transformed[key] = value;
    });
    return { id: item.id, ...transformed };
  });
}

// Hàm tách chuỗi phần 2 để chống mất đáp án 
export function seperatePart2(data) {
  let obj = {}
  let parts = data.match(/a\d(ĐÚNG|SAI)/g);
  parts?.forEach(part => {
    let key = part.slice(0, 2);
    let value = part.slice(2);
    obj[key] = value;
  });
  return obj;
}

// Gộp đáp án lại thành 1 chuỗi phần 2 Math
export function CombineAnswerPart2(ansPart2) {
  ansPart2?.map(item => {
    const { id, ...rest } = item;
    const valueString = Object.entries(rest)
      .map(([key, value]) => `${key}${value}`)
      .join('');

    return {
      id: id,
      value: valueString
    };
  });
}

// Biến đáp án từ object thành chuỗi
export function formatObjectToString(obj) {
  return Object.entries(obj)
    .filter(([key, value]) => value)
    .map(([key, value]) => `${key}${value}`)
    .join('');
}
